import { useMemo } from "react";
import { usePlaceStore } from "store/placeStore";

export function useShowOpeningHoursAndContact(): boolean {
	const { place } = usePlaceStore();
	const show = useMemo(() => Boolean(place), [place]);
	return show;
}
